export const API_URL = {
  USER_LOGIN: "/user-login",
  SOCIAL_LOGIN: "/social-login",
  APPLE_VERIFICATION: "/apple-verification",
  SHORT_URL: "/shorty/shorten",
  AUTH_APPROVAL: "/approvals",
  EMAIL_VERIFICATION:'/pipelines/tokens'
};
